import styled, { css } from "styled-components";
import { BlueBirdTheme } from "@kitbird/core";

interface CardBodyProps {
  layout?: "grid" | "flex";
  gridTemplateColumns?: string;
  flexDirection?: "row" | "column";
  flexWrap?: "wrap" | "nowrap";
}

export const CardContainer = styled.div`
  border: 1px solid ${BlueBirdTheme.colors.secondary[200]};
  border-radius: 8px;
  padding: 24px;
  background-color: #fff;
  overflow-y: auto;
  max-height: 60vh;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 20px;
`;

export const CardTitle = styled.div``;

export const CardSelectAll = styled.div``;

export const CardBody = styled.div<CardBodyProps>`
  gap: 24px;
  ${({
    layout = "grid", gridTemplateColumns, flexDirection, flexWrap,
  }) => (
    layout === "flex" ? css`
          display: flex;
          flex-direction: ${flexDirection || "column"};
          flex-wrap: ${flexWrap || "nowrap"};
        ` : css`
          display: grid;
          grid-template-columns: ${gridTemplateColumns};
        `)}
  `;
